import { render, staticRenderFns } from "./financeiro-liquidacoes-recebiveis.vue?vue&type=template&id=4055a3bf"
import script from "./financeiro-liquidacoes-recebiveis.vue?vue&type=script&lang=ts"
export * from "./financeiro-liquidacoes-recebiveis.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports